<template lang="html">
  <b-card style="padding:40px;">
    <h5><b>AMEND CHANGES (PURCHASE ORDER)</b></h5>
    <hr />

    <b-row>
      <b-col md="5">
        <b-form-group>
          <label for="input-default">
            Product Name<span class="danger-new"> *</span>
          </label>
          <multiselect
            v-model="input.product_name"
            :options="product_name"
            :custom-label="nameWithSKU"
            placeholder="Please select"
            label="name"
            track-by="name"
          ></multiselect>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <label for="input-default">
            Quantity<span class="danger-new"> *</span>
          </label>

          <b-form-input
            v-model="input.qty"
            id="input-horizontal"
            class="input-new"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <b-button variant="primary" size="m" @click="onClickAdd">+</b-button>
          &nbsp;&nbsp;&nbsp;
          <b-button variant="danger" size="m" @click="onClickReset">x</b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-size`">Product Type</label>
          <b-form-input
            v-model="form.type"
            id="input-horizontal"
            type="text"
            class="input-new"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-table
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickEdit(data.index)"
          >
            EDIT
          </b-button>
          &nbsp;&nbsp;&nbsp;
          <b-button @click="onClickDel(data.index)" variant="primary" size="sm">
            DELETE
          </b-button>
        </span>
      </template>
    </b-table>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickSubmit"
          >SUBMIT</b-button
        >
      </b-col>
    </b-row>

    <b-modal id="delete-modal" title="Delete">
      <p class="my-4">Are you confirm to delete?</p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          Close
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDelConfirm">
          Delete
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
// import moment from "moment";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      input: {
        pro_stock_id: null,
        product_name: "",
        qty: ""
      },

      form: {
        type: ""
      },

      items: [],

      // Current Index
      curIndex: "",

      product_name: [],

      error: {
        product_name: "",
        qty: ""
      },

      tabIndex: 0,

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "qty",
          sortable: true
        },
        {
          label: "Action",
          key: "action",
          sortable: false
        }
      ]
    };
  },

  created() {
    this.getPO();
    this.getProduct();
    this.form.type = this.$route.query.pro_cat === 1 ? "UHT" : "Pasteurized";
  },

  methods: {
    // Get Stockout
    getPO() {
      this.$store
        .dispatch("showStockout", {
          category: 2,
          stock_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            res.data.data.pro_stock.forEach(element => {
              this.items.push({
                name: element.product.name,
                sku: element.product_id,
                qty: element.quantity,
                index: element.index
              });
            });
          }
        });
    },

    // For Multiselect purpose
    nameWithSKU({ name, sku }) {
      return `${name} — [${sku}]`;
    },

    // Get Outlet
    getProduct() {
      let param = "?type=" + this.$route.query.pro_cat;
      this.$store.dispatch("getProduct", param).then(res => {
        res.data.data.forEach((element, index) => {
          this.product_name.push({
            sku: element.product_id,
            name: element.name,
            index: index
          });
        });
      });
    },

    onClickDel(index) {
      this.curIndex = index;
      this.$bvModal.show("delete-modal");
    },

    // Delete
    onClickDelConfirm() {
      this.items.splice(this.curIndex, 1);
      this.curIndex = 0;
      this.$bvModal.hide("delete-modal");
      this.onClickReset();
    },

    // Edit
    onClickEdit(index) {
      this.curIndex = index;

      let input = {
        sku: this.items[index].sku,
        name: this.items[index].name
      };
      this.input.product_name = input;
      this.input.qty = this.items[index].qty;
    },

    // Add
    onClickAdd() {
      if (this.curIndex !== "") {
        this.items[this.curIndex].name = this.input.product_name.name;
        this.items[this.curIndex].sku = this.input.product_name.sku;
        this.items[this.curIndex].qty = this.input.qty;
      } else {
        this.items.push({
          isActive: true,
          name: this.input.product_name.name,
          sku: this.input.product_name.sku,
          qty: this.input.qty
        });
      }

      this.onClickReset();
    },

    // Reset
    onClickReset() {
      this.input.product_name = "";
      this.input.qty = "";
      this.curIndex = "";
    },

    onClickBack() {
      this.$router.go(-1);
    },

    onClickSubmit() {
      let final_product = [];
      this.items.forEach(item => {
        final_product.push({
          product_id: item.sku,
          quantity: item.qty
        });
      });
      this.$store
        .dispatch("createMultiStock", {
          category: 5,
          product: final_product,
          stock_id: this.$route.query.id,
          category_amend: 2,
          type: this.$route.query.pro_cat
        })
        .then(res => {
          if (res.data.response.code === 1) {
            this.$router.push({ path: `stockout_changes_user` });
          }
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
